// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresCustomGridRenameBody = {
  poolId: string;
  gridId: string;
  title: string;
  topLabel?: string | null;
  sideLabel?: string | null;
};

export type typeSquaresCustomGridRenameOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    gridId: string;
    eventId: string;
    title: string;
    topLabel: string;
    sideLabel: string;
  };
};

export type typeSquaresCustomGridRenameOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresCustomGridRenameOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresCustomGridRenameOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresCustomGridRenameBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    title: { type: "string", maxLength: 3000, minLength: 1 },
    topLabel: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    sideLabel: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["poolId", "gridId", "title"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresCustomGridRename(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresCustomGridRenameBody);
  }

  return async function postSquaresCustomGridRename(
    payload: typeSquaresCustomGridRenameBody,
  ): Promise<
    typeSquaresCustomGridRenameOutput200 | typeSquaresCustomGridRenameOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresCustomGridRename" failed before calling the network. #fcf79d8c4aa9`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#fcf79d8c4aa9" },
        },
        data: null,
      } as typeSquaresCustomGridRenameOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/custom-grid-rename`,
      httpMethod: "POST",
      options,
    })) as
      | typeSquaresCustomGridRenameOutput200
      | typeSquaresCustomGridRenameOutput400;
  };
}
